module.exports = __webpack_public_path__ + "img/c_2.332252a2.jpg";